import type { FaireProductEntity } from "../../entity_types/product";

export const p_gt3cygp2mq: FaireProductEntity = {
  token: "p_gt3cygp2mq",
  type: "product",
  name: "Baking Duck Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/49b9418bc1e49da974a6f4a8764415db6c2f1fb5d046fc7eebf52095d23f7d63.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0021e825d77ea62fc881cec96e8c8c76a9d1c3fab874476af4dfa0669322352c.jpeg",
    "https://cdn.faire.com/fastly/5cb936d0c87c0392b2565cf7a64102e6b8a5801ec66f95e3cd90ad9cf5565df1.jpeg",
    "https://cdn.faire.com/fastly/2b738ab6b0cdf3ee23d2e88ab1e55891a1cb65276cf3fdb693ffdc26b6d6f590.jpeg",
    "https://cdn.faire.com/fastly/68fd7168b8be240769698ef5da47d41ec55f2c8e843384c48b8b55582820eb1a.jpeg",
    "https://cdn.faire.com/fastly/85bf663d2eb47cfa17ce6232bc8f5f7cda4a165e87a779a8cf74bfd74c846e7f.jpeg",
    "https://cdn.faire.com/fastly/3d0c63293886190c0b503885f38375d29794b51b49d0d7b9cb2804b3dc440f55.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Whimsical Collection featuring an all-over design displaying a charming scene of a cute duck character baking pies that is replicated from original hand illustrated artwork. Double-sided towel displays a coordinating plaid pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our Baking Duck kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A cute garden-themed kitchen accessory that easily adds personality to any kitchen.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:07.180Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
